import { SynchronousStorageService } from '../SynchronousStorageService';

export class LocalStorageService extends SynchronousStorageService {
  protected storage: Storage = localStorage;

  constructor() {
    super()
  }
}
